import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const PersonalService = {
  async getAllRows(filters = {}) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Personal`, { params: filters });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }

    return {
      status: 0,
      message: "Erreur de chargement du personnel",
      data: [],
    };
  },

  async getDetail(personnelId) {
    try {
      const result = await axios.get(`${apiUrl}/Partner/Personal/detail`, {
        params: { personnel_id: personnelId },
      });
      return result.data;
    } catch (error) {
      return error.response?.data || { status: false, data: [] };
    }
  },
};

export default PersonalService;
